// Couleur de chaque indice de PV initial (00 à 99) ; "__" désigne un PV subséquent
const indiceColors = {
  '00': '#757575',
  '01': '#757575',
  '02': '#757575',
  '03': '#757575',
  '04': '#757575',
  '05': '#757575',
  '06': '#757575',
  '07': '#757575',
  '08': '#757575',
  '09': '#757575',
  '10': '#9c27b0',
  '11': '#827717',
  '12': '#00838f',
  '13': '#d32f2f',
  '14': '#388e3c',
  '15': '#1976d2',
  '16': '#e65100',
  '17': '#689f38',
  '18': '#0277bd',
  '19': '#c2185b',
  '20': '#9e9d24',
  '21': '#0097a7',
  '22': '#d84315',
  '23': '#558b2f',
  '24': '#1565c0',
  '25': '#ad1457',
  '26': '#afb42b',
  '27': '#00acc1',
  '28': '#bf360c',
  '29': '#33691e',
  '30': '#0d47a1',
  '31': '#880e4f',
  '32': '#827717',
  '33': '#006064',
  '34': '#e64a19',
  '35': '#558b2f',
  '36': '#0288d1',
  '37': '#ad1457',
  '38': '#9e9d24',
  '39': '#0097a7',
  '40': '#f4511e',
  '41': '#7cb342',
  '42': '#303f9f',
  '43': '#c2185b',
  '44': '#9e9d24',
  '45': '#0288d1',
  '46': '#ef6c00',
  '47': '#8bc34a',
  '48': '#0277bd',
  '49': '#d81b60',
  '50': '#689f38',
  '51': '#0288d1',
  '52': '#8e24aa',
  '53': '#f9a825',
  '54': '#00838f',
  '55': '#e64a19',
  '56': '#7cb342',
  '57': '#1565c0',
  '58': '#aa00ff',
  '59': '#9e9d24',
  '60': '#00acc1',
  '61': '#ef6c00',
  '62': '#7cb342',
  '63': '#0d47a1',
  '64': '#880e4f',
  '65': '#9e9d24',
  '66': '#0097a7',
  '67': '#e64a19',
  '68': '#8bc34a',
  '69': '#1565c0',
  '70': '#ad1457',
  '71': '#9e9d24',
  '72': '#00acc1',
  '73': '#ef6c00',
  '74': '#7cb342',
  '75': '#0d47a1',
  '76': '#aa00ff',
  '77': '#9e9d24',
  '78': '#00acc1',
  '79': '#e65100',
  '80': '#7cb342',
  '81': '#0288d1',
  '82': '#757575',
  '83': '#757575',
  '84': '#757575',
  '85': '#ef6c00',
  '86': '#689f38',
  '87': '#1565c0',
  '88': '#c2185b',
  '89': '#afb42b',
  '90': '#00acc1',
  '91': '#ef6c00',
  '92': '#7cb342',
  '93': '#0d47a1',
  '94': '#880e4f',
  '95': '#9e9d24',
  '96': '#757575',
  '97': '#757575',
  '98': '#7cb342',
  '99': '#0288d1',
  '__': '#2196f3',
};

/**
 * Couleur associée à un indice ; un code inconnu prend la couleur du PV subséquent
 * @param {string} indiceCode - Le code de l'indice
 * @returns {string} La couleur hexadécimale
 */
export const getIndiceColor = (indiceCode) => indiceColors[indiceCode] || indiceColors.__;
